"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { ModalBaseCloseButton } from "../ModalBase/ModalBaseCloseButton.mjs";
import { useDrawerContext } from "./Drawer.context.mjs";
import Drawer_module_default from "./Drawer.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Drawer/DrawerCloseButton.tsx
const DrawerCloseButton = factory((_props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("DrawerCloseButton", null, _props);
	return /* @__PURE__ */ jsx(ModalBaseCloseButton, {
		...useDrawerContext().getStyles("close", {
			classNames,
			style,
			styles,
			className
		}),
		...others
	});
});
DrawerCloseButton.classes = Drawer_module_default;
DrawerCloseButton.displayName = "@mantine/core/DrawerCloseButton";
//#endregion
export { DrawerCloseButton };

//# sourceMappingURL=DrawerCloseButton.mjs.map